import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "var(--main-color)",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 20C0 8.9543 8.9543 0 20 0C25.3043 0 30.3914 2.10714 34.1421 5.85786C37.8929 9.60859 40 14.6957 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20ZM4.00012 20C4.00012 28.8365 11.1636 36 20.0001 36C24.2436 36 28.3132 34.3143 31.3138 31.3137C34.3144 28.3131 36.0001 24.2435 36.0001 20C36.0001 11.1634 28.8367 3.99999 20.0001 3.99999C11.1636 3.99999 4.00012 11.1634 4.00012 20Z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M20 18.9502C14.201 18.9502 9.5 23.6512 9.5 29.4502C9.5 30.2786 10.1716 30.9502 11 30.9502C11.8284 30.9502 12.5 30.2786 12.5 29.4502C12.5 25.3081 15.8579 21.9502 20 21.9502C24.1421 21.9502 27.5 25.3081 27.5 29.4502C27.5 30.2786 28.1716 30.9502 29 30.9502C29.8284 30.9502 30.5 30.2786 30.5 29.4502C30.5 23.6512 25.799 18.9502 20 18.9502Z" }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M26 11.75C26 15.0637 23.3137 17.75 20 17.75C16.6863 17.75 14 15.0637 14 11.75C14 8.43629 16.6863 5.75 20 5.75C23.3137 5.75 26 8.43629 26 11.75ZM23.0001 11.7507C23.0001 10.0938 21.6569 8.75067 20.0001 8.75067C18.3432 8.75067 17.0001 10.0938 17.0001 11.7507C17.0001 13.4075 18.3432 14.7507 20.0001 14.7507C21.6569 14.7507 23.0001 13.4075 23.0001 11.7507Z"
		})
	]
});
export { SvgProfile as ReactComponent };
